/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 11/10/2022
 */
import QwoachFile from "@shared/Drive/QwoachFile";
import {QwoachFileType} from "@shared/Drive/QwoachFileType";

export default class LinkItem extends QwoachFile {

	type: QwoachFileType = QwoachFileType.LINK


	constructor(name: string = null, url: string = null) {
		super(name, "", url);
		this.mimeType = "link"
	}
}
